import { CustomRouteObject } from "./navItems";
import { Box, MenuItem, MenuList, Popper } from "@mui/material";
import { NavLink, NavLinkProps } from "react-router-dom";
import { ExpandMore } from "@mui/icons-material";
import React, { ReactElement } from "react";

const Link = React.forwardRef<HTMLAnchorElement, Partial<NavLinkProps>>((props, ref) => <NavLink to={""} {...props} ref={ref} />);

export default function TopMenuLink(navItem: CustomRouteObject): ReactElement {
  const isExpandable = navItem.children && navItem.children.length > 0;
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMouseOver = (event: React.MouseEvent<HTMLElement>) => {
    if (isExpandable) {
      setAnchorEl(event.currentTarget);
      setOpen(true);
    }
  };

  return (
    <Box onMouseLeave={() => setOpen(false)}>
      <MenuItem dense component={Link} to={navItem.path ?? "/"} onMouseOver={handleMouseOver} sx={{ height: "48px" }}>
        {navItem.title}
        {isExpandable && <ExpandMore />}
      </MenuItem>
      <Popper open={open} anchorEl={anchorEl} keepMounted disablePortal>
        <MenuList sx={{ paddingTop: 0 }}>
          {navItem.children?.map((child) => (
            <MenuItem dense key={child.title} component={Link} to={child.path ?? ""}>
              {child.title}
            </MenuItem>
          ))}
        </MenuList>
      </Popper>
    </Box>
  );
}
